import { Card, CardProps, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { Link, LinkProps } from 'react-router';

interface Props extends CardProps {
  children: ReactNode;
  to: LinkProps['to'];
  sx?: CardProps['sx'];
  variant?: 'outlined' | 'elevation';
}

export default function PreviewCard({ children, to, sx, variant = 'outlined', ...props }: Props) {
  const theme = useTheme();
  return (
    <Card
      component={Link}
      variant={variant}
      sx={{
        flexGrow: 1,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        textDecoration: 'none',
        gap: 1,
        '& img': {
          transition: 'transform 350ms ease-in-out',
        },
        '&:hover img': {
          transform: 'scale(1.05)',
        },
        [theme.breakpoints.down('md')]: {
          padding: theme.spacing(0),
        },
        ...sx,
      }}
      {...props}
      to={to}
    >
      {children}
    </Card>
  );
}
